import { SvgIcon } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { ToggleableIconProps } from "../../../../types/IconProps";
import { getIconColor } from "../../../../services/iconService";

const IconImportant = ({ active = false, sx = {} }: ToggleableIconProps) => {
  const theme = useTheme();

  return (
    <SvgIcon sx={sx} viewBox="0 0 300 300">
      <path
        style={{ fill: getIconColor(active, theme) }}
        d="m150.01,191.4c-15.99,0-29,13-29,28.97s13.01,29,29,29,28.97-13.01,28.97-29-13-28.97-28.97-28.97Zm0,49.47c-11.3,0-20.5-9.19-20.5-20.5s9.2-20.47,20.5-20.47,20.47,9.18,20.47,20.47-9.18,20.5-20.47,20.5Z"
      />
      <path
        style={{ fill: getIconColor(active, theme) }}
        d="m150.01,50.63c-17.07,0-29,13.57-29,33,0,8.47,2.26,31.41,6.5,52.47,7.79,38.67,16.57,43.14,22.5,43.14s14.7-4.47,22.48-43.14c4.24-21.05,6.49-44,6.49-52.47,0-19.43-11.92-33-28.98-33Zm14.15,83.8c-5.99,29.79-12.25,36.31-14.15,36.31s-8.16-6.52-14.16-36.31c-4.08-20.25-6.34-42.88-6.34-50.79,0-11.3,5.37-24.5,20.49-24.5s20.47,13.2,20.47,24.5c0,7.91-2.25,30.55-6.33,50.79Z"
      />
      <path
        style={{ fill: getIconColor(active, theme) }}
        d="m22.56,196.69C-1.88,130.2,29.64,55.33,94.32,26.23c64.68-29.1,141.62-3.01,175.16,59.38,1.11,2.07,3.69,2.84,5.76,1.73,2.07-1.11,2.84-3.69,1.73-5.76-17.24-32.07-45.77-56.24-80.33-68.06C161.9,1.65,124.33,3.41,90.83,18.48,57.34,33.54,31.1,60.5,16.95,94.37c-14.09,33.71-14.93,71.09-2.37,105.26.63,1.72,2.26,2.79,3.99,2.79.49,0,.98-.08,1.47-.26,2.2-.81,3.33-3.25,2.52-5.46Z"
      />
      <path
        style={{ fill: getIconColor(active, theme) }}
        d="m285.42,100.37c-.81-2.21-3.26-3.33-5.46-2.52-2.2.81-3.33,3.25-2.52,5.46,24.44,66.49-7.08,141.37-71.76,170.46-17.9,8.05-36.73,11.88-55.33,11.88-48.6,0-95.57-26.14-119.82-71.26-1.11-2.07-3.69-2.85-5.76-1.73-2.07,1.11-2.84,3.69-1.73,5.76,17.24,32.07,45.77,56.24,80.33,68.06,15.21,5.2,30.96,7.79,46.68,7.79,20.18,0,40.29-4.26,59.12-12.73,33.49-15.07,59.73-42.02,73.89-75.89,14.09-33.71,14.93-71.09,2.37-105.26Z"
      />
    </SvgIcon>
  );
};

export default IconImportant;
